import React, {useState} from 'react';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {can} from '../../../_common/components/Permissions';
import {
  subjects as S,
  permissionTypes as T
} from '../../../_common/constants/permissionSubjects';
import ButtonAction from '../../../_common/components/ButtonAction';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalHeader from '../../../_common/components/ModalHeader';
import {FormattedMessage} from 'react-intl';
import ModalContent from '../../../_common/components/ModalContent';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';
import {usePopupCopyInspectionContext} from "../PopupCopyInspectionContext";
import PopupForm from './PopupForm';

const PopupCopyInspection = ({data}) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const isDisabled = data.originTypeID !== 1 || !can(T.FULL, S.INSPECTIONS_PAGE);
  const {handleSubmit, formik: {isValid}} = usePopupCopyInspectionContext();

  return (
    <>
      <ButtonAction
        iconButtonType={'warning'}
        variant={'icon'}
        label={
          <img
            src={toAbsoluteUrl('media/common/Copy_yellow.svg')}
            alt={'copy'} className="w-20px h-20px"
          />
        }
        title={TTS.COPY_INSPECTION}
        onClick={() => handleShowModal()}
        disabled={isDisabled}
        customClassnames={'my-1'}
      />
      <ModalContainer show={show} onClose={handleCloseModal} size={'xl'}>
        <ModalHeader
          type={'complex'}
          icon={'/media/common/Edit_primary.svg'}
          header={
            <FormattedMessage
              id="inspections-popup-copy-header"
              defaultMessage="Copy inspection {id}"
              values={{id: data.firmShumaID}}
            />
          }
        />
        <ModalContent>
          <PopupForm data={data}/>
        </ModalContent>
        <ModalButtonsContainer>
          <ButtonAction
            variant={'cancel'}
            onClick={handleCloseModal}
            label={<FormattedMessage id="inspections-popup-copy-cancel" defaultMessage="Cancel"/>}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={<FormattedMessage id="inspections-popup-copy-submit" defaultMessage="Copy"/>}
            onClick={() => {
              handleSubmit(data.shumaID);
              handleCloseModal();
            }}
            disabled={!isValid}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupCopyInspection;
